module.exports = __webpack_public_path__ + "static/media/linkedin-white.ccd3e22a.svg";